/**
 * La lista de los audios de cada pronunciación de los heterónimos (`senseAudio.ts`).
 * GENERADO por docs/design/lexicon/tools/audio-significado/llevar-a-speak.mjs:
 * no editar a mano. Palabra → pronunciación (tal como la escribe el diccionario)
 * → URL del mp3 en `public/audio-significado/`.
 */

/** La voz de diccionario con la que se generaron (Nora). */
export const SENSE_AUDIO_VOICE = 'OYTbf65OHHFELVut7v2H';

export const SENSE_AUDIO: Readonly<Record<string, Readonly<Record<string, string>>>> = {
  abuse: {
    əbˈjus: '/audio-significado/abuse-a.473a49e694.mp3',
    əbˈjuz: '/audio-significado/abuse-b.ce71e8da04.mp3',
  },
  affiliate: {
    əˈfɪliət: '/audio-significado/affiliate-a.b4d3598fd5.mp3',
    əˈfɪliˌeɪt: '/audio-significado/affiliate-b.4875c30de5.mp3',
  },
  appropriate: {
    əˈpɹoʊpɹiət: '/audio-significado/appropriate-a.34c64cbd7e.mp3',
    əˈpɹoʊpɹiˌeɪt: '/audio-significado/appropriate-b.0e5bfb79d0.mp3',
  },
  approximate: {
    əˈpɹɑksəmət: '/audio-significado/approximate-a.62cd61c4c0.mp3',
    əˈpɹɑksəˌmeɪt: '/audio-significado/approximate-b.d034c7bafd.mp3',
  },
  articulate: {
    ɑɹˈtɪkjəˌleɪt: '/audio-significado/articulate-a.e2c7fba85f.mp3',
    ɑɹˈtɪkjələt: '/audio-significado/articulate-b.9f0f8c5de7.mp3',
  },
  associate: {
    əˈsoʊsiˌeɪt: '/audio-significado/associate-a.0d051d2fba.mp3',
    əˈsoʊsiət: '/audio-significado/associate-b.2c089bcb54.mp3',
  },
  attribute: {
    ˈætɹəbˌjut: '/audio-significado/attribute-a.5f47ea0b51.mp3',
    əˈtɹɪbˌjut: '/audio-significado/attribute-b.c577a7861d.mp3',
  },
  bow: {
    ˈboʊ̯: '/audio-significado/bow-a.609b6612e4.mp3',
    ˈbaʊ: '/audio-significado/bow-b.7538718677.mp3',
  },
  close: {
    ˈkloʊz: '/audio-significado/close-a.9cf1d8efcf.mp3',
    ˈkloʊs: '/audio-significado/close-b.cc9e86e67f.mp3',
  },
  closer: {
    ˈkloʊsɚ: '/audio-significado/closer-a.cd6a892048.mp3',
    ˈkloʊzɝ: '/audio-significado/closer-b.f35fd6097f.mp3',
  },
  combine: {
    kəmˈbaɪn: '/audio-significado/combine-a.14324492de.mp3',
    ˈkɑmbaɪn: '/audio-significado/combine-b.86667d8ab5.mp3',
  },
  compound: {
    ˈkɑmpaʊnd: '/audio-significado/compound-a.892af514eb.mp3',
    kəmˈpaʊnd: '/audio-significado/compound-b.50010bb775.mp3',
  },
  compress: {
    kəmˈpɹɛs: '/audio-significado/compress-a.0142655303.mp3',
    ˈkɑmpɹɛs: '/audio-significado/compress-b.708027a0ad.mp3',
  },
  conflict: {
    ˈkɑnflɪkt: '/audio-significado/conflict-a.eaebba38fd.mp3',
    kənˈflɪkt: '/audio-significado/conflict-b.0812393c1d.mp3',
  },
  console: {
    kənˈsoʊl: '/audio-significado/console-a.a20976b3ab.mp3',
    ˈkɑnsoʊl: '/audio-significado/console-b.2f95e9ed62.mp3',
  },
  construct: {
    kənˈstɹəkt: '/audio-significado/construct-a.6d4ea8f07d.mp3',
    ˈkɑnstɹəkt: '/audio-significado/construct-b.3623097528.mp3',
  },
  content: {
    ˈkɑntɛnt: '/audio-significado/content-a.40b8417577.mp3',
    kənˈtɛnt: '/audio-significado/content-b.c33de0e54b.mp3',
  },
  contest: {
    ˈkɑntɛst: '/audio-significado/contest-a.bb474915e7.mp3',
    kənˈtɛst: '/audio-significado/contest-b.5753eda5dc.mp3',
  },
  contract: {
    ˈkɑnˌtɹækt: '/audio-significado/contract-a.f5425d6869.mp3',
    kənˈtɹækt: '/audio-significado/contract-b.f1fd2b25b4.mp3',
  },
  converse: {
    kənˈvɝs: '/audio-significado/converse-a.f5f264a888.mp3',
    ˈkɑnvɝs: '/audio-significado/converse-b.50356b8464.mp3',
  },
  convert: {
    kənˈvɝt: '/audio-significado/convert-a.5465db91e1.mp3',
    ˈkɑnvɝt: '/audio-significado/convert-b.9556d0c657.mp3',
  },
  convict: {
    ˈkɑnvɪkt: '/audio-significado/convict-a.558dec281d.mp3',
    kənˈvɪkt: '/audio-significado/convict-b.6c1a83db56.mp3',
  },
  coordinate: {
    koʊˈɔɹdəˌneɪt: '/audio-significado/coordinate-a.5257f5fe33.mp3',
    koʊˈɔɹdənət: '/audio-significado/coordinate-b.8a6204e8f5.mp3',
  },
  correlate: {
    ˈkɔɹəleɪt: '/audio-significado/correlate-a.c1baaf5be2.mp3',
    ˈkɔɹələt: '/audio-significado/correlate-b.ed5d3a66ec.mp3',
  },
  defect: {
    ˈdifɛkt: '/audio-significado/defect-a.f9aa1c7666.mp3',
    dɪˈfɛkt: '/audio-significado/defect-b.a1652e2e62.mp3',
  },
  defense: {
    dɪˈfɛns: '/audio-significado/defense-a.2b8e7c2128.mp3',
    ˈdifɛns: '/audio-significado/defense-b.631d182970.mp3',
  },
  delegate: {
    ˈdɛləˌɡeɪt: '/audio-significado/delegate-a.39cb971e5b.mp3',
    ˈdɛləɡət: '/audio-significado/delegate-b.1d36b29e05.mp3',
  },
  desert: {
    ˈdɛzɝt: '/audio-significado/desert-a.576b90f382.mp3',
    dɪˈzɝt: '/audio-significado/desert-b.60131cec7d.mp3',
  },
  diffuse: {
    dɪfˈjus: '/audio-significado/diffuse-a.a1af9df97d.mp3',
    dɪfˈjuz: '/audio-significado/diffuse-b.628a5bc5e9.mp3',
  },
  duplicate: {
    ˈdupləkət: '/audio-significado/duplicate-a.94de2518b9.mp3',
    ˈdupləˌkeɪt: '/audio-significado/duplicate-b.234d87a285.mp3',
  },
  elaborate: {
    ɪˈlæbɝˌeɪt: '/audio-significado/elaborate-a.d132853785.mp3',
    ɪˈlæbɹət: '/audio-significado/elaborate-b.770ae0e057.mp3',
  },
  estimate: {
    ˈɛstəˌmeɪt: '/audio-significado/estimate-a.6c76649332.mp3',
    ˈɛstəmət: '/audio-significado/estimate-b.292f713129.mp3',
  },
  excuse: {
    ɪkˈskjuz: '/audio-significado/excuse-a.dcfe1e9ec2.mp3',
    ɪkˈskjus: '/audio-significado/excuse-b.5cd574a186.mp3',
  },
  intimate: {
    ˈɪntɪmət: '/audio-significado/intimate-a.47cfc25867.mp3',
    ˈɪntəˌmeɪt: '/audio-significado/intimate-b.d6577b204f.mp3',
  },
  lead: {
    ˈlid: '/audio-significado/lead-a.6209979692.mp3',
    ˈlɛd: '/audio-significado/lead-b.591adf85dc.mp3',
  },
  live: {
    ˈlɪv: '/audio-significado/live-a.6ee29a2cec.mp3',
    ˈlaɪv: '/audio-significado/live-b.3dbe9a71fc.mp3',
  },
  minute: {
    ˈmɪnət: '/audio-significado/minute-a.db616122c4.mp3',
    maɪnˈjut: '/audio-significado/minute-b.a7a7b66032.mp3',
  },
  moderate: {
    ˈmɑdɝət: '/audio-significado/moderate-a.b8cc4af522.mp3',
    ˈmɑdɝˌeɪt: '/audio-significado/moderate-b.b14ff00f16.mp3',
  },
  object: {
    ˈɑbdʒɛkt: '/audio-significado/object-a.4e0ebe7b04.mp3',
    əbˈdʒɛkt: '/audio-significado/object-b.f033a34e9f.mp3',
  },
  present: {
    ˈpɹɛzənt: '/audio-significado/present-a.9653a5d52e.mp3',
    pɹiˈzɛnt: '/audio-significado/present-b.45097fef52.mp3',
  },
  produce: {
    pɹəˈdus: '/audio-significado/produce-a.792a967b77.mp3',
    ˈpɹoʊdus: '/audio-significado/produce-b.ede3419510.mp3',
  },
  progress: {
    ˈpɹɑˌɡɹɛs: '/audio-significado/progress-a.7c0fd84c98.mp3',
    pɹəˈɡɹɛs: '/audio-significado/progress-b.02fdb9a466.mp3',
  },
  project: {
    ˈpɹɑdʒɛkt: '/audio-significado/project-a.5e8c592c96.mp3',
    pɹəˈdʒɛkt: '/audio-significado/project-b.6a7b29853a.mp3',
  },
  rebel: {
    ˈɹɛbəl: '/audio-significado/rebel-a.257af37e7a.mp3',
    ɹɪˈbɛl: '/audio-significado/rebel-b.01bb74df21.mp3',
  },
  record: {
    ˈɹɛkɝd: '/audio-significado/record-a.e7bd392b96.mp3',
    ɹəˈkɔɹd: '/audio-significado/record-b.d83df0af43.mp3',
  },
  refuse: {
    ɹəfˈjuz: '/audio-significado/refuse-a.9cbfe98ae8.mp3',
    ˈɹɛfˌjuz: '/audio-significado/refuse-b.db65b38b44.mp3',
  },
  reject: {
    ɹɪˈdʒɛkt: '/audio-significado/reject-a.c67e417bd4.mp3',
    ˈɹidʒɛkt: '/audio-significado/reject-b.5f908c2777.mp3',
  },
  resume: {
    ˈɹɛzəˌmeɪ: '/audio-significado/resume-a.7a88d96f23.mp3',
    ɹɪˈzum: '/audio-significado/resume-b.418e7c22a2.mp3',
  },
  row: {
    ˈɹoʊ: '/audio-significado/row-a.12e477e4d8.mp3',
    ˈɹaʊ: '/audio-significado/row-b.0fe0f99761.mp3',
  },
  segment: {
    ˈsɛɡmənt: '/audio-significado/segment-a.42ccfd0c50.mp3',
    ˌsɛɡˈmɛnt: '/audio-significado/segment-b.d71bab530f.mp3',
  },
  separate: {
    ˈsɛpɝɪt: '/audio-significado/separate-a.0c3fbf15b8.mp3',
    ˈsɛpɝˌeɪt: '/audio-significado/separate-b.60daa4216d.mp3',
  },
  subordinate: {
    səˈbɔɹdɪnət: '/audio-significado/subordinate-a.e896aedb91.mp3',
    səˈbɔɹdəˌneɪt: '/audio-significado/subordinate-b.7e1d28dd6c.mp3',
  },
  tear: {
    ˈtɪɹ: '/audio-significado/tear-a.3208d5cce2.mp3',
    ˈtɛɹ: '/audio-significado/tear-b.d720b64a7d.mp3',
  },
  use: {
    ˈjuz: '/audio-significado/use-a.f324c872be.mp3',
    ˈjus: '/audio-significado/use-b.eac67fc7e8.mp3',
  },
  wind: {
    ˈwɪnd: '/audio-significado/wind-a.c85883120f.mp3',
    ˈwaɪnd: '/audio-significado/wind-b.2f2e3621ad.mp3',
  },
};

/** Los heterónimos que quedaron sin audios, con el motivo: suenan con el audio de la palabra. */
export const SENSE_AUDIO_MISSING: Readonly<Record<string, string>> = {
  abstract:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  advocate: 'no se confirmó /ædvəkət/ en 4 intentos',
  alternate: 'no se confirmó /ɔltɝneɪt/ en 4 intentos',
  animate: 'no se confirmó /ænəmət/ en 4 intentos',
  august:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  bass: 'no se confirmó /bæs/ en 4 intentos',
  compact: 'no se confirmó /kəmpækt/ en 4 intentos',
  conduct:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  decrease: 'no se confirmó /dɪkɹis/ en 4 intentos',
  digest:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  discard:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  escort:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  exploit:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  extract: 'no se confirmó /ɪkstɹækt/ en 4 intentos',
  graduate: 'no se confirmó /ɡɹædʒuwət/ en 4 intentos',
  house: 'no se confirmó /haʊz/ en 4 intentos',
  impact:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  implant:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  import:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  incense:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  increase:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  insert:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  insult:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  intern:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  mismatch:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  outright:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  overall:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  overflow:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  overlay:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  override:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  overrun:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  overthrow:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  perfect: 'no se confirmó /pɝfɪkt/ en 4 intentos',
  predicate:
    'el verbo («basar en») no tiene una frase corta natural que termine con él: siempre lleva «on» y un objeto',
  primer: 'no se confirmó /pɹɪməɹ/ en 4 intentos',
  protest: 'no se confirmó /pɹətɛst/ en 4 intentos',
  rebound:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  recount: 'no se confirmó /ɹɪkaʊnt/ en 4 intentos',
  refund: 'no se confirmó /ɹɪfənd/ en 4 intentos',
  reset:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  subject: 'no se confirmó /səbdʒɪkt/ en 4 intentos',
  suspect:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  'tear up': 'no se confirmó /tɪɹ əp/ en 4 intentos',
  torment:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  transfer:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
  upset:
    'sus dos pronunciaciones cambian sólo el acento, y el control del acento no anduvo (acento.json)',
};
